(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barracambiante"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('cl-cintillo-pro')) {

    customElements.define(
      'cl-cintillo-pro',
      class extends HTMLElement {

        connectedCallback() {

          this.cleanup = new AbortController();

          this.messages = Array.from(
            this.querySelectorAll('[data-message]')
          );

          this.currentIndex = 0;

          this.interval = Math.max(
            2000,
            Number(this.dataset.interval) || 4000
          );

          this.reduceMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

          this.hovering = false;

          if (this.messages.length > 1) {

            const options = {
              signal: this.cleanup.signal
            };

            if (this.dataset.pauseHover === 'true') {

              this.addEventListener(
                'pointerenter',
                (event) => {

                  if (event.pointerType === 'mouse') {
                    this.hovering = true;
                    this.restartMessages();
                  }

                },
                options
              );

              this.addEventListener(
                'pointerleave',
                () => {

                  this.hovering = false;
                  this.restartMessages();

                },
                options
              );

            }

            this.addEventListener(
              'focusin',
              () => this.restartMessages(),
              options
            );

            this.addEventListener(
              'focusout',
              () => {

                cancelAnimationFrame(this.focusFrame);

                this.focusFrame = requestAnimationFrame(
                  () => this.restartMessages()
                );

              },
              options
            );

            document.addEventListener(
              'visibilitychange',
              () => this.restartMessages(),
              options
            );

            this.reduceMotion.addEventListener?.(
              'change',
              () => this.restartMessages(),
              options
            );

            this.restartMessages();

          }

          this.initPaper();

        }

        restartMessages() {

          clearInterval(this.messageTimer);

          if (
            !this.isConnected ||
            this.messages.length < 2 ||
            this.reduceMotion.matches ||
            document.hidden ||
            this.hovering ||
            this.contains(document.activeElement)
          ) {
            return;
          }

          this.messageTimer = setInterval(() => {

            this.currentIndex =
              (this.currentIndex + 1) % this.messages.length;

            this.messages.forEach((message, index) => {

              const active = index === this.currentIndex;

              message.classList.toggle(
                'is-active',
                active
              );

              message.setAttribute(
                'aria-hidden',
                String(!active)
              );

            });

          }, this.interval);

        }

        initPaper() {

          this.paperRow = this.querySelector(
            '[data-paper-row]'
          );

          this.paperTrack = this.querySelector(
            '[data-paper-track]'
          );

          this.originalTile = this.querySelector(
            '[data-paper-original]'
          );

          this.originalImage = this.querySelector(
            '[data-paper-image]'
          );

          if (
            !this.paperRow ||
            !this.originalTile ||
            !this.originalImage
          ) {
            return;
          }

          const update = () => {

            cancelAnimationFrame(this.paperFrame);

            this.paperFrame = requestAnimationFrame(
              () => this.fillPaper()
            );

          };

          const onError = () => {

            const alternative =
              this.originalImage.dataset.fallbackUrl;

            if (
              alternative &&
              !this.originalImage.dataset.triedFallback
            ) {

              this.originalImage.dataset.triedFallback =
                'true';

              this.paperTrack
                .querySelectorAll('[data-paper-copy]')
                .forEach((copy) => copy.remove());

              this.originalTile
                .querySelectorAll('source')
                .forEach((source) => source.remove());

              this.originalImage.removeAttribute(
                'srcset'
              );

              this.originalImage.src = alternative;

            } else {

              this.dataset.imageState = 'error';

            }

          };

          const onLoad = () => {

            this.dataset.imageState = 'loaded';

            update();

          };

          const options = {
            signal: this.cleanup.signal
          };

          this.originalImage.addEventListener(
            'load',
            onLoad,
            options
          );

          this.originalImage.addEventListener(
            'error',
            onError,
            options
          );

          window.addEventListener(
            'resize',
            update,
            options
          );

          if ('ResizeObserver' in window) {

            this.paperResizeObserver =
              new ResizeObserver(update);

            this.paperResizeObserver.observe(
              this.paperRow
            );

          }

          if (this.originalImage.complete) {

            if (this.originalImage.naturalWidth > 0) {
              onLoad();
            } else {
              onError();
            }

          }

        }

        fillPaper() {

          if (
            !this.isConnected ||
            !this.paperRow ||
            this.dataset.imageState === 'error'
          ) {
            return;
          }

          const tileWidth =
            this.originalTile.getBoundingClientRect().width;

          if (tileWidth < 1) {
            return;
          }

          const count =
            this.paperRow.dataset.repeat === 'true'
              ? Math.min(
                  48,
                  Math.ceil(
                    this.paperRow.clientWidth / tileWidth
                  ) + 2
                )
              : 1;

          const existing = Array.from(
            this.paperTrack.querySelectorAll(
              '[data-paper-copy]'
            )
          );

          if (existing.length === count - 1) {
            return;
          }

          existing.forEach(
            (copy) => copy.remove()
          );

          for (let i = 1; i < count; i++) {

            const copy =
              this.originalTile.cloneNode(true);

            copy.removeAttribute(
              'data-paper-original'
            );

            copy.setAttribute(
              'data-paper-copy',
              ''
            );

            const image = copy.querySelector(
              '[data-paper-image]'
            );

            image?.removeAttribute(
              'data-paper-image'
            );

            image?.removeAttribute(
              'data-fallback-url'
            );

            this.paperTrack.appendChild(copy);

          }

        }

        disconnectedCallback() {

          clearInterval(this.messageTimer);

          cancelAnimationFrame(this.focusFrame);
          cancelAnimationFrame(this.paperFrame);

          this.paperResizeObserver?.disconnect();

          this.cleanup?.abort();

        }

      }
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const carousel = document.querySelector('.collection-carousel');
  const items = document.querySelectorAll('.collection-item');
  const prevButton = document.querySelector('.carousel-prev');
  const nextButton = document.querySelector('.carousel-next');
  
  let currentIndex = 0;

  // Función para mover el carrusel
  function moveCarousel() {
    const itemWidth = items[0].offsetWidth + 20; // Tamaño de los items + gap
    carousel.style.transform = `translateX(-${currentIndex * itemWidth}px)`;
  }

  // Botón "Siguiente"
  nextButton.addEventListener('click', function() {
    if (currentIndex < items.length - 1) {
      currentIndex++;
    } else {
      currentIndex = 0; // Volver al primer item
    }
    moveCarousel();
  });

  // Botón "Anterior"
  prevButton.addEventListener('click', function() {
    if (currentIndex > 0) {
      currentIndex--;
    } else {
      currentIndex = items.length - 1; // Volver al último item
    }
    moveCarousel();
  });
  
  // Mover carrusel cada 3 segundos (auto)
  setInterval(function() {
    nextButton.click();
  }, 3000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("popup-wrapper");
  const content = popup.querySelector(".popup-content");
  const closeBtn = popup.querySelector(".popup-close");
  const images = popup.querySelectorAll(".popup-slider .popup-image");
  const slider = popup.querySelector(".popup-slider");
  const activeLink = document.getElementById("popup-active-link");

  let current = 0;
  let intervalTime = parseInt(content.dataset.slideInterval) * 1000 || 4000;
  let transitionType = content.dataset.transition || "fade";
  let autoCloseTime = parseInt(content.dataset.autoClose) || 0;

  slider.classList.add(transitionType);

  setTimeout(() => {
    popup.classList.add("active");

    if(autoCloseTime > 0){
      setTimeout(() => {
        popup.classList.remove("active");
      }, autoCloseTime * 1000);
    }
  }, 2000);

  closeBtn.addEventListener("click", () => {
    popup.classList.remove("active");
  });

  if(images.length > 1){
    setInterval(() => {
      images[current].classList.remove("active");
      current = (current + 1) % images.length;
      images[current].classList.add("active");

      const link = images[current].dataset.link;
      if(link) activeLink.href = link;
    }, intervalTime);
  }
});

  } catch(e) { console.error(e); }
})();
})();
